module.exports = __webpack_public_path__ + "static/media/ic-quiz.b8a9d42e.svg";